var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDevice = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.6,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M0 2.286C0 .969 1.131 0 2.4 0h12.8c1.269 0 2.4.969 2.4 2.286v7.428c0 1.317-1.131 2.286-2.4 2.286H9.6v2.4h2.8a.8.8 0 1 1 0 1.6H5.2a.8.8 0 1 1 0-1.6H8V12H2.4C1.131 12 0 11.031 0 9.714V2.286ZM2.4 1.6c-.499 0-.8.362-.8.686v7.428c0 .324.301.686.8.686h12.8c.499 0 .8-.362.8-.686V2.286c0-.324-.301-.686-.8-.686H2.4Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDevice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/device.16a667bc.svg";
export { ForwardRef as ReactComponent };